<div class="pagetitle">
  <!-- <h1 class="mb-2">{{CurrentRoute}}</h1> -->
  <nav>
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/home">Home</a></li>
      <ng-container *ngFor="let item of CurrentPath.split('/')">
        <li class="breadcrumb-item active" *ngIf="item && item !== 'home'">{{ item }}</li>
      </ng-container>
    </ol>
  </nav>
</div>
